import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const testPing = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/test/ping'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
	}
}

const testApi = {
	testPing: testPing,
}

export default testApi
